import type { ReactNode } from 'react';
import { cx } from '../../lib/cx';

/** A titled group of settings: small section label above a white card (Figma "YOU" / "App & browser" blocks). */
export function SettingsSection({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cx('flex flex-col gap-(--mbm-space-3)', className)}>
      <h2 className="px-(--mbm-space-1) text-label-small text-text-section uppercase">{title}</h2>
      {children}
    </section>
  );
}

/** Row used by Security / Notifications: icon tile, title + subtitle, trailing control. */
export function SettingsRow({
  icon,
  title,
  subtitle,
  badge,
  trailing,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  badge?: ReactNode;
  trailing?: ReactNode;
}) {
  return (
    <div className="flex items-center gap-(--mbm-space-4) py-(--mbm-space-3)">
      <span className="flex size-(--mbm-size-icon-tile-large) shrink-0 items-center justify-center rounded-(--mbm-component-radius-icon-tile) bg-surface-tint text-text-primary">
        {icon}
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="flex items-center gap-(--mbm-space-2) text-label-large text-text-primary">
          {title}
          {badge}
        </span>
        {subtitle ? <span className="text-body-small text-text-secondary">{subtitle}</span> : null}
      </div>
      {trailing}
    </div>
  );
}
